<template>
    <div v-if="address" :class="{'cursor-pointer': !hideShowOnMapButton}" @click.stop="showOnMap">
        <div class="d-flex align-start text-subtitle-2" :class="{'ms-4': !isShowIcon}">
            <small>
                <v-icon v-if="isShowIcon" color="info" size="small" style="line-height: 20px">mdi-map-marker</v-icon>
            </small>
            <span>
                <span v-if="venueName" class="font-weight-medium">{{ venueName }},</span>
                <span v-if="address" class="text-grey ml-1 font-weight-regular">{{ address }}</span>
            </span>
        </div>
        <div
            v-if="!hideShowOnMapButton"
            class="hotel-address__show-map ms-4 text-caption text-primary text-decoration-underline text-lowercase"
        >
            {{ $t('show_on_map') }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import {CHANGE_TAB_MOBILE_EVENT, EventBus, SHOW_ON_MAP_EVENT} from '~/utils/event-bus'

    const props = defineProps<{
        venueName: string
        address: string
        hideShowOnMapButton: boolean
        isShowIcon?: boolean
        offer?: any
    }>()

    const app = useNuxtApp()

    const showOnMap = () => {
        if (!props.offer) return
        if (app.$breakpoint.smAndDown) {
            EventBus.$emit(CHANGE_TAB_MOBILE_EVENT, 2)
        }
        EventBus.$emit(SHOW_ON_MAP_EVENT, props.offer)
    }
</script>
